export const GALLERY = {
    FILTER_BTN: "filter-btn",
    CLEAR_DATES: "clear-dates",
    ITEM_TILE: "item-tile",
    ITEM_ID: "data-test-item-id",
    ITEM_ACTIONS: "item-actions",
    ITEM_CART_BUTTON: "item-order",
    ITEM_CART_ICON: "item-cart-icon",
    ITEM_TILE_TEXT: "item-tile-text",
    ITEM_TILE_IMAGE: "item-tile-image",
    ITEM_CARD: "item-card",
    BULK_SEARCH_BTN: "bulk-search-btn",
    SIMPLE_SEARCH_BTN: "simple-search-btn",
    SEARCH_INPUT: "search-input",
    APPLY_SEARCH_BTN: "apply-search-btn",
    ITEM_BULK_SELECT: "item-bulk-select",
    BULK_MORE_ACTIONS: "bulk-more-actions",
    BULK_ADD_TO_CATALOG: "add-to-catalog",
    BULK_CREATE_NEW_CATALOG: "bulk-create-new-catalog",
    BULK_SELECT_ALL: "bulk-select-all",
    FILTER_CHIP: "filter-chip",
    BULK_ADD_TO_ORDER: "add-to-order",
    BULK_ADD_TO_LIST: "add-to-list",
    BULK_EXPORT: "bulk-export",
    BULK_DELETE_SELECTED: "bulk-delete-selected",
    BULK_ADDTO_TOP: "bulk-addto-top",
    BULK_ADDTO_BOTTOM: "bulk-addto-bottom",
    EXPORT_ACTION: "export-action",
    EXPORT_LINK: "export-link",
    EXPORT_CSV: "export-csv",
    EXPORT_XLS: "export-xls",
    EXPORT_VERTICAL: "export-vertical",
    EXPORT_HORIZONTAL: "export-horizontal",
    EXPORT_XLS_ORDER_FORM: "export-xls-order-form",
    EXPORT_ATS_REPORT: "export-ats-report",
    ITEM_PREVIEW_MODAL: "item-preview-modal",
    ITEM_PREVIEW_MODAL_CUSTOMIZATION: "item-preview-modal-customization",
    ITEM_PREVIEW: "item-preview",
    ITEM_PREVIEW_IMAGE: "item-preview-image",
    ITEM_PREVIEW_HEADER: "item-preview-header",
    ITEM_HEADER_TITLE: "item-header-title",
    ITEM_PREVIEW_PRICE: "item-preview-price",
    MEDIA_UPLOAD_MENU_BTN: "media-upload-menu-btn",
    UPLOAD_360_IMAGES: "upload-360-images",
    UPLOAD_VIDEO: "upload-video",
    UPLOAD_IMAGES: "upload-images",
    UPLOAD_3D: "upload-3D",
    MANAGE_PRODUCT_MEDIA: "manage-product-media",
    IMAGE_MAGNIFY_CONTAINER: "image-magnify-container",
    THUMBS_CONTAINER: "thumbs-container",
    SIZE_INPUT: "size-input",
    ITEM_VIEW_TOGGLE: {
        PANEL: "panel-view",
        CARD: "card-view",
        LIST: "list-view",
    },
    CURRENCY_SELECTOR: "currency-selector",
    MANAGE_MEDIA_IMAGES: "manage-media-images",
    COLOR_CHIPS: "color-chips",
    COLOR_CHIP: "color-chip",
    CAROUSEL_ARROW: "carousel-arrow",
    ITEM_DETAILS: "item-details",
    ITEM_CUSTOMIZATIONS: "item-customization",
    ITEM_CUSTOMIZATIONS_ATTRIBUTE: "item-customization-attribute",
    MORE_COLORS_COUNT: "more-colors-count",
    SWATCH_CONTAINER: "swatch-container",
    CLOSE_SWATCH_CONTAINER: "close-swatch-container",
    ADD_ALL_COLORS: "add-all-colors",
    REMOVE_ALL_COLORS: "remove-all-colors",
    SWATCH_HOVER_ZOOM: "swatch-hover-zoom",
    SWATCH_CART_ICON: "swatch-cart-icon",
    SWATCH: "swatch",
    VARIANT_COUNT: "variant-count",
    SHIP_START: "ship-start",
    SELECTED_COLOR: "selected-color",
    PROMOTION_NO_COMPANY: "promotion-no-company",
    PROMOTION_NO_COMPANY_SELECT: "promotion-no-company-select",
    COMPANY_SELECTION_CONFIRM: "company-selection-confirm",
    COMPANY_SELECTION_CANCEL: "company-selection-cancel",
    COMPANY_SELECTION_INPUT: "company-selection-input",
    COMPANY_SELECTION_OPTION: "company-selection-option",
    LIST_VIEW_PRICE_CELL: "list-view-price-cell",
    INVENTORY_FILTER: {
        INVENTORY_FILTER_CHEVRON: "chevron-inventory",
        INVENTORY_FILTER_CONDITION: "inventory-condition",
        INVENTORY_FILTER_CONDITION_OPTION: "inventory-condition-option",
    },
};
